import { Tooltip } from '@mui/material';

import { BlockTextField } from '../../ConfigFields/TextField';

interface ConditionLabelFieldProps {
  fieldNamePrefix: string;
}

export function ConditionLabelField(props: ConditionLabelFieldProps) {
  const { fieldNamePrefix } = props;
  return (
    <BlockTextField
      key="label"
      fieldName={`${fieldNamePrefix}.label`}
      label={
        <Tooltip placement="top" arrow title="Add a concise label to display within the block.">
          <span>Condition Alias</span>
        </Tooltip>
      }
      aria-label="Condition Alias"
    />
  );
}
